export const MENU_ITEM_LINK_TYPE = {
  NONE: 'none', // label only, no link
  HISTORY: 'history', // front-end only link leveraging browser.history
  STANDARD: 'standard' // full HTTP request to server
};
